import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Downloads = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const DownloadLink = styled.a`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.semantic.action.primary};
  border: 1px solid ${({ theme }) => theme.colors.semantic.border.default};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.semantic.surface.card};

  &:hover {
    color: ${({ theme }) => theme.colors.semantic.action.primary};
    text-decoration: none;
  }
`;
